import { getQueryParameter } from 'services/utils/strings'
import { getCurrentViewPort } from '../common'
import { PAGE_PREFIX } from '../constants/validations'
import history from '../history'
// method to trigger analytics window event and populate data on window

export const hour = `${new Date().getHours()}:00`

export const setAnalyticsMetadata = (metaData) => {
  const analytics = window.analytics || {}
  window.analytics = { ...analytics, ...metaData }
}

const globalAnalyticsMetaData = () => {
  const viewPort = getCurrentViewPort()
  const requestOrigin = getQueryParameter('request_origin') || 'asda'
  const referrer = document.referrer || ''
  const platform = getQueryParameter('platform') || 'webapp'
  const isSignedIn = window.analytics && window.analytics.isSignedIn
    ? window.analytics.isSignedIn : false
  return {
    hour,
    viewPort,
    requestOrigin,
    referrer,
    platform,
    isSignedIn,
  }
}

export const populateAnalyticsMetadata = (metaData) => {
  const analytics = window.analytics || {}
  window.analytics = {
    ...analytics,
    ...metaData,
    ...globalAnalyticsMetaData(),
  }
}

export const trackSignalEvent = (event, metaData = {}, callBackFunction = null) => {
  // create and dispatch the event
  try {
    const detail = { ...metaData, ...globalAnalyticsMetaData() }
    populateAnalyticsMetadata(metaData)
    const custEvent = new CustomEvent(event, { detail })
    setTimeout(() => {
      window.dispatchEvent(custEvent)
      if (callBackFunction) {
        callBackFunction()
      }
    }, 500)
    console.log(event)
    console.log(window.analytics)
  } catch (error) {
    console.log(`Can't dispatch a custom event because of: ${error}`)
  }
}

const pageViewTrigger = () => setTimeout(() => trackSignalEvent('triggerOmniturePageView'), 1000)

export const initAnalytics = () => {
  // Currently just being used for Scan & Go pages
  pageViewTrigger()
  history.listen(() => pageViewTrigger())
}

export const viewport = () => {
  const width = window.innerWidth
  if (width <= 321) {
    return 'Small'
  } else if (width <= 481) {
    return 'Medium'
  } else if (width <= 768) {
    return 'Large'
  } else if (width <= 961) {
    return 'Default'
  } else if (width <= 1025) {
    return 'XL'
  }
  return 'XXL'
}

export const successAndRedirectTrigger = (page, redirecturl) => {
  setAnalyticsMetadata({ isSignedIn: true })
  trackSignalEvent(`triggerOmniture${page}Success`, {
    pageName: `${PAGE_PREFIX}${page} Page`,
  }, () => {
    trackSignalEvent(`triggerOmniture${page}SuccessRedirect`, {
      pageName: `${PAGE_PREFIX}${page} Page`,
    }, () => {
      setTimeout(() => {
        window.location.assign(redirecturl)
      }, 300)
    })
  })
}
